import React, { createContext, useContext, useState, ReactNode } from 'react';

export interface DateOfBirthValues {
    year: string;
    month: string;
    day: string;
}

interface AgeGateContextType {
    isAgeValid: boolean | null;
    setIsAgeValid: (valid: boolean | null) => void;
    isConfirmingAge: boolean;
    setIsConfirmingAge: (confirming: boolean) => void;
    dateOfBirth: DateOfBirthValues | null;
    setDateOfBirth: (values: DateOfBirthValues | null) => void;
}

const AgeGateContext = createContext<AgeGateContextType | undefined>(undefined);

interface AgeGateProviderProps {
    children: ReactNode;
}

export const AgeGateProvider: React.FC<AgeGateProviderProps> = ({ children }) => {
    const [isAgeValid, setIsAgeValid] = useState<boolean | null>(null);
    const [isConfirmingAge, setIsConfirmingAge] = useState(false);
    const [dateOfBirth, setDateOfBirth] = useState<DateOfBirthValues | null>(null);

    return (
        <AgeGateContext.Provider
            value={{
                isAgeValid,
                setIsAgeValid,
                isConfirmingAge,
                setIsConfirmingAge,
                dateOfBirth,
                setDateOfBirth
            }}
        >
            {children}
        </AgeGateContext.Provider>
    );
};

export const useAgeGate = (): AgeGateContextType => {
    const context = useContext(AgeGateContext);
    if (context === undefined) {
        throw new Error('useAgeGate must be used within an AgeGateProvider');
    }
    return context;
};
